/* Screens that own the whole display.
 *
 * The app renders a few overlays globally, outside the router: a language
 * nudge pinned to the top, a cookie banner pinned to the bottom, toasts. That
 * is right for a page you scroll. It is wrong for a viewfinder with one
 * button, where the top overlay covers the header and the bottom one would
 * cover the shutter itself -- the single interaction the screen has.
 *
 * Kept as a list rather than a prop drilled through the tree because the
 * overlays are siblings of the router, not children of the page.
 */
export const BARE_ROUTES = ['/id'];

export function isBareRoute(pathname) {
    return BARE_ROUTES.includes(String(pathname || '').replace(/\/+$/, '') || '/');
}
